import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/b05e588d-5161-4e8a-9fc5-c87d2449f69a.png"
              alt="Localygo"
              className="h-40 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-300">
              La plateforme de livraison locale de Localygo
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Accueil</Link></li>
              <li><Link to="/restaurants" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Restaurants</Link></li>
              <li><Link to="/boutiques" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Boutiques</Link></li>
              <li><Link to="/commander" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Commander</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Pour les livreurs</h4>
            <ul className="space-y-2">
              <li><Link to="/livreur" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Devenir livreur</Link></li>
              <li><Link to="/connexion" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Connexion</Link></li>
              <li><Link to="/a-propos" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">À propos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Pour les partenaires</h4>
            <ul className="space-y-2">
              <li><Link to="/partenaire" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Devenir partenaire</Link></li>
              <li><Link to="/connexion" className="text-sm text-teal-50 hover:text-white transition-colors cursor-pointer">Espace partenaire</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Suivez-nous</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-teal-50">© 2025 Localygo. Tous droits réservés.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-sm text-teal-50 hover:text-white transition-colors mt-4 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
